/**
 * DISCLOSABLE COMPONENT
 *
 * The disclosable component handles div-containers than can be
 * disclosed by setting an input to a specific value
 */
$(function () {

	$('[disclosed-by]').each((nodeId, node) => {
		let disclosedBySelector	= $(node).attr('disclosed-by');
        const negateCheck = $(node).attr('disclosed-negate') !== undefined;

		//
		// Get all input values that disclose the element (comma-separated string in attribute)
		let disclosedValue		= $(node).attr('disclosed-value') || null;
		if (disclosedValue !== null) {
			disclosedValue = disclosedValue.split(',');
		}

		let unanimous		= false;
		let disclosedType	= $(node).attr('disclosed-type') || null;
		if (disclosedType !== null && disclosedType == 'all') {
			unanimous = true;
		}

		let discloser = null;
		if (disclosedBySelector.startsWith('name:')) {
			const name	= disclosedBySelector.split(':')[1];
			discloser	= $(`[name="${ name }"]`).first();
		} else {
			discloser = $('#' + disclosedBySelector);
		}

		//
		// The element that discloses the container must be unique
		if (discloser.length != 1) {
			return;
		}

		discloser = discloser.get(0);

		//
		// Disclose general input changes
		if (discloser.tagName == 'INPUT' && (discloser.type == 'text' || discloser.type == 'hidden')) {
			let disclosingValues = disclosedValue || [];
			$(discloser).on('input', event => {
				let disclose					= false;
				let disclosingValuesEvaluated	= [];

				disclosingValues.forEach(value => {

					//
					// Check "starts with" rule
					if (value.startsWith('$')) {
						const magicKey = value.substr(1);
						switch(value.substr(1)) {
							case 'unmapped': {

								//
								// Push true if the value is an unmapped diagnosis
								const mapped = [
									'D07.4','D29.0','D07.5','D29.1','D40.0','D29.2','D40.1','D29.3','D29.4',
									'D30.0','D41.0','D30.1','D41.1','D30.2','D41.2','D09.0','D30.3','D41.4'
								];
								disclosingValuesEvaluated.push(discloser.value.startsWith('D') && !mapped.includes(discloser.value));
							}
						}
						return;
					}

					//
					// Check "starts with" rule
					if (value.startsWith('^=')) {
						const checkValue = value.substr(2);
						disclosingValuesEvaluated.push(discloser.value.startsWith(checkValue));
						return;
					}

					//
					// Check "does not starts with" rule
					if (value.startsWith('!^=')) {
						const checkValue = value.substr(3);
						disclosingValuesEvaluated.push(!discloser.value.startsWith(checkValue));
						return;
					}

					disclosingValuesEvaluated.push(discloser.value == value);
				});

				const evaluated = disclosingValuesEvaluated.reduce(function (carry, evaluation) {
					if (unanimous) {
						return carry && evaluation;
					} else {
						return carry || evaluation;
					}
				}, unanimous ? true : false);

				if (evaluated) {
					node.classList.remove('d-none');
				} else {
					node.classList.add('d-none');
				}
			});
		}

		//
		// Disclose by select changes
		if (discloser.tagName == 'SELECT') {
			let disclosingValues = disclosedValue || ['1'];
			$(discloser).change(function () {
				if (disclosingValues.includes(discloser.value)) {
					node.classList.remove('d-none');
				} else {
					node.classList.add('d-none');
				}
			});
		}

		//
		// Disclosed by radio button changes
		if (discloser.tagName == 'INPUT' && discloser.type == 'radio') {
			let disclosingValues	= disclosedValue === null ? [disclosedBySelector] : disclosedValue.concat([disclosedBySelector]);
			let groupName			= $(discloser).attr('name');
			$(document).on('click change', `[name="${groupName}"]`, function (event) {
				let anyChecked = false;
				disclosingValues.forEach(value => {
					anyChecked = anyChecked || $('#' + value).is(':checked');
				})

                //
                // Usually the element should be dislosed if any of the values is checked (so remove the d-none class)
                // If the negateCheck attribute is set, the element should be disclosed if none of the values is checked (thats why we switch the add/remove classes)
				if (anyChecked) {
					node.classList[negateCheck ? 'add' : 'remove']('d-none');
				} else {
					node.classList[negateCheck ? 'remove' : 'add']('d-none');
				}
			});
		}

		//
		// Disclosed by checkbox changes
		if (discloser.tagName == 'INPUT' && discloser.type == 'checkbox') {
			let checkboxName		= $(discloser).attr('name');
			let disclosingValues	= disclosedValue || [discloser.value] || ['1'];
			$(document).on('change', `[name="${checkboxName}"]`, function (event) {
				let checkedValues = [];
				$(`[name="${checkboxName}"]`).each((index, item) => {
					if ($(item).is(':checked')) {
						checkedValues.push($(item).val());
					}
				});

				//
				// We found an intersection between the disclosing and the checked values
				const intersection = disclosingValues.filter(value => checkedValues.includes(value));
				if (intersection.length > 0) {
					node.classList.remove('d-none');
				} else {
					node.classList.add('d-none');
				}
			});
		}

	});
});
